<div class="lift-margin-left c-portlet_box_specs" style="position: relative">
	<app-loader [showLoader]="showLoad"></app-loader>
	<div
		class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary c-portlet_box_specs {{
			sectionclass
		}}"
		style="position: relative"
	>
		<!--		Header when there is data  -->
		<div class="c-portlet o-block u-width-100p _u-width-100p u-border-bottom o-stack__cell" style="position: relative">
			<h5 class="title primary-color">Lift Trend</h5>
		</div>
		<div>
			<div class="c-portlet__content u-pt-small" style="width: 100%" *ngIf="campaignCarouselItem">
				<div class="o-stack o-stack--center o-stact_ImgSpecs">
					<div class="charts-container product-lift-chart-container" style="margin: 0 auto">
						<div class="chart-layout">
							<div class="o-stack__cell u-relative campaign-navigations">
								<a class="c-icon c-icon&#45;&#45;main u-color-minor u-opacity-50p" style="margin-left: 14%">
									<span class="next" (click)="prevArrow()" class="carousel-arrow-style">
										<i class="fa fa-angle-left" aria-hidden="true" *ngIf="campaignsList.length > 1"></i>
									</span>
								</a>
								<span class="campaign-name-r11">{{ campaignCarouselItem.name }}</span>
								<a class="c-icon c-icon&#45;&#45;main u-color-minor u-opacity-50p" style="margin-right: 14%">
									<span
										class="prev"
										(click)="nextArrow()"
										class="carousel-arrow-style"
										*ngIf="campaignsList.length > 1"
									>
										<i class="fa fa-angle-right" aria-hidden="true" *ngIf="campaignsList.length > 1"></i>
									</span>
								</a>
							</div>
							<div [id]="'campaign' + i" class="individual-chart" style="min-height: 200px">
								<app-chart class="individual-chart" [chartData]="campaignCarouselItem"></app-chart>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div class="no-data-container" *ngIf="!hasData">
		<div
			class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary c-portlet_box_specs {{
				sectionclass
			}}"
			style="position: relative"
		>
			<!--		Header when there is NO data  -->
			<div
				class="c-portlet o-block u-width-100p _u-width-100p u-border-bottom o-stack__cell"
				style="position: relative"
			>
				<h5 class="title primary-color">Lift Trend</h5>
			</div>
		</div>
		<div class="map-no-data">No Data to Display</div>
	</div>
</div>
